import Dexie from 'dexie'
import { MessageChatLLMTypes } from '~/interfaces/llm'

export type LLMChatMessage = {
  id?: number
  feedbackId?: string
  medicalRecord: string
  content?: string
  typeMessage: MessageChatLLMTypes
}

class HStoryIndexedDB extends Dexie {
  llmChatMessages!: Dexie.Table<LLMChatMessage, number>

  constructor() {
    super('hiae-hstory-indexeddb')
    this.version(1).stores({
      llmChatMessages: '++id, medicalRecord, content, typeMessage'
    })

    this.llmChatMessages = this.table('llmChatMessages')
  }
}

export const db = new HStoryIndexedDB()
